import { useEffect, useState } from "react";

import {
  LANGUAGE_LABEL,
  language,
  nextLanguage,
  onLanguageChange,
  setLanguage,
  type Language,
} from "../../i18n";

/**
 * English or Spanish, for the person holding the phone (ADR 0325).
 *
 * One small button in the top bar, beside the theme switch, that says what
 * tapping it will do: it reads "ES" while the app is in English and "EN"
 * while it is in Spanish. The choice is remembered on this phone. It changes
 * only what staff read — a customer's page, a crew's packet and everything
 * sent out stay in English whatever this says.
 */
export function LanguageButton() {
  const [now, setNow] = useState<Language>(language);
  useEffect(() => onLanguageChange(setNow), []);

  const next = nextLanguage(now);
  const label =
    now === "en"
      ? `Idioma: ${LANGUAGE_LABEL.en}. Cambiar a ${LANGUAGE_LABEL.es}.`
      : `Language: ${LANGUAGE_LABEL.es}. Switch to ${LANGUAGE_LABEL.en}.`;

  return (
    <button
      type="button"
      className="themebtn langbtn"
      title={label}
      aria-label={label}
      onClick={() => setLanguage(next)}
    >
      {next.toUpperCase()}
    </button>
  );
}
